export enum MandatoryOptionalCodeEnum {
    Optional = 'Optional',
    Mandatory = 'Manditory',
}
